<template>
  <b-nav tabs class="open-to-work-tabs mb-4">
    <b-nav-item :to="{ name: 'open-to-work.profile-page' }" exact>
      My Profile
    </b-nav-item>
    <b-nav-item :to="{ name: 'open-to-work.requests-page' }">
      Requests
    </b-nav-item>
    <b-nav-item
      :to="{ name: 'open-to-work.jobs-page' }"
      :active="$route.name === 'open-to-work.job-page'"
    >
      Jobs
    </b-nav-item>
    <b-nav-item :to="{ name: 'open-to-work.applications-page' }">
      My Applications
    </b-nav-item>
  </b-nav>
</template>

<script>
export default {
  name: 'OpenToWorkTabs',
}
</script>

<style lang="scss" scoped>
.open-to-work-tabs {
  /deep/ .nav-link {
    font-weight: 600;
    color: #6c7581;

    &.active {
      color: #212529;
    }
  }
}
</style>
